import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Button, Select, MenuItem } from '@mui/material'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import { useForm, Controller } from 'react-hook-form';
import * as businessUnitActions from '../../store/actions/businessUnit';
import countryLisJson from '../../config/countryList';
import * as Styled from '../../components/styled-components/Styled-Components';
import { useLogout } from '../../components/Utils';
import { useTranslation } from 'react-i18next';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}
const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};


const ViewBusinessUnit = ({setBreadcrumb, getBusinessUnitDetails, businessUnitData, countriesList,getAllCountriesAndCurrency}) => {
    const { t } = useTranslation('common');

    const navigate = useNavigate();
    const { name } = useParams();
    const [locationList, setLocationList] = useState([ ]);
    const [bunitData, setBunitData] = useState(null)
    const { register, handleSubmit, formState: { errors }, clearErrors, control, setValue } = useForm();
    const [countryList, setCountryList] = useState([]);
    const onLogout = useLogout();

    useEffect(() => {
        const subMenuData = {
            name: t("Business Units & Locations"),
            route: "/business-units",
            subRoutes: "view-businessunit",
            subRoutesLabel: t("View"),
            isSubMenu: true
        }
        setBreadcrumb(subMenuData);
        getAllCountriesAndCurrency()
      }, []);

      useEffect(() => {
        getBusinessUnitDetails(name);
      },[]);

      useEffect(() => {
        if(countriesList && countriesList?.status === 200){
            setCountryList(countriesList?.data)
        } else if(countriesList && countriesList?.status === 401){ 
            onLogout();
        }
      }, [countriesList]);

    useEffect(() => {
        if (businessUnitData?.businessUnitDetails && businessUnitData?.businessUnitDetails?.data && businessUnitData?.businessUnitDetails?.data?.status === 200 && businessUnitData?.businessUnitDetails?.data?.data?.businessUnitName === name) {
            setBunitData(businessUnitData?.businessUnitDetails?.data?.data);
            setLocationList(businessUnitData?.businessUnitDetails?.data?.data?.businessLocation)
        } else  if (businessUnitData?.businessUnitDetails && businessUnitData?.businessUnitDetails?.status === 401) {
            onLogout();
        }
         else if (businessUnitData?.isError && !businessUnitData?.isLoading) {
        }
    }, [businessUnitData?.businessUnitDetails?.data?.data]);

 
    return <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t("Business Units & Locations")}</b></h1>
                </Grid>
            </Grid>
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form>
                <Grid container spacing={2}>

                <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Business Unit Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                margin="normal"
                                id="businessName"
                                sx={textboxCss}
                                value={bunitData?.businessUnitName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "Business name" }}
                            />
                        </div>
                    </Grid>
                    <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                        <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-bold'>{t("Associated Locations")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                    </Grid>
                    
                    <Grid container spacing={2}>
                    <Grid item md={12} xl={8} lg={8} sm={12} xs={12}>
                    {locationList?.length !== 0 ? 
                    <Grid item container spacing={2} className="pl-0 m-0">
                          <Grid item xs={3} sm={2} md={2}>
                            <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Location")} </Typography>
                          </Grid>
                          <Grid item xs={9} sm={6} md={6}>
                           <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Address")} </Typography>
                          </Grid>
                          <Grid item xs={5} sm={2} md={2}>
                           <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Country")} </Typography>
                          </Grid>
                          <Grid item xs={5} sm={2} md={2}>
                            <Typography component="p" sx={{ color: appConfig.colors.black }} className='xxs-normal'>{t("Currency")} </Typography>
                          </Grid>
                        </Grid> : ''}
                    {locationList?.map((obj, index) => (
                        <Grid item container spacing={2} className="pl-0 m-0" key={obj?.id}>
                          <Grid item xs={3} sm={2} md={2}>
                          <TextField
                                margin="normal"
                                id="locationName"
                                value={obj?.locationName}
                                disabled
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "location" }}
                            />
                         </Grid>
                          <Grid item xs={9} sm={6} md={6}>
                          <TextField
                                margin="normal"
                                id="locationAddress"
                                value={obj?.address}
                                disabled
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "address" }}
                            />
                          </Grid>
                          <Grid item xs={5} sm={2} md={2}>
                          <Controller
                            name={`country[${index}]`}
                            control={control}
                            defaultValue={obj.countryId}
                            render={({ field }) => (
                                <Select
                                {...field}
                                value={obj.countryId} // Set the value from the form state
                                disabled
                                // onChange={(e) => {
                                //     field.onChange(e);
                                //     // onChangeInput(e, 'country', obj.id, index);
                                // }}
                                className='normal-dropdown xxs-normal'
                                inputProps={{ 'aria-label': 'Without label' }}
                                >
                                 {countryList && countryList?.map((item, i) => (
                                    <MenuItem key={i} className='xxs-normal filter-item' value={item.id} >
                                    {item.countryName}
                                    </MenuItem>
                                ))}
                                </Select>
                            )}
                            />
                          </Grid>
                          <Grid item xs={5} sm={2} md={2}>
                          <Controller
                                name={`currency[${index}]`}
                                control={control}
                                defaultValue={obj.currency || 'usd'}
                                render={({ field }) => (
                                <Select
                                    {...field}
                                    value={obj?.currency}
                                    disabled
                                    sx={{textTransform: 'uppercase'}}
                                    className='normal-dropdown xxs-normal'
                                    inputProps={{ 'aria-label': 'Without label' }}
                                >
                                     {countryList?.map((item, i) => (
                                    <MenuItem key={i} className='xxs-normal filter-item' value={item.currency} style={{textTransform:'uppercase'}} >
                                        {item.currency}
                                    </MenuItem>
                                    ))}
                                </Select>
                                )}
                            />
                          </Grid>
                        </Grid>
                        ))}
                    </Grid>
                   
                    </Grid>
                    <Grid item md={8} xl={8} lg={8} sm={12} xs={12}>
                        <div >
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => navigate('/business-units')}
                        >
                            {t("Cancel")} 
                        </Styled.CancelButton>
                        </div>
                    </Grid>
                </Grid>
            </form>
    </div >
}

ViewBusinessUnit.propTypes = {
    businessUnitData: PropTypes.arrayOf(PropTypes.array).isRequired,
    getBusinessUnitDetails: PropTypes.func.isRequired,
    setBreadcrumb: PropTypes.func.isRequired,
}


const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        getBusinessUnitDetails: (data) => dispatch(businessUnitActions.getBusinessUnitDetails(data)),
        getAllCountriesAndCurrency: (data) => dispatch(businessUnitActions.getAllCountriesAndCurrency(data))

    };
}
const mapStateToProps = (state) => ({ 
    businessUnitData: state.businessUnit,
    countriesList: state.businessUnit.countriesList

 })


export default connect(mapStateToProps, mapDispatchToProps)(ViewBusinessUnit);